
export { isProduction } from "/app/shared/utils/common/src/environment-utils.ts"